import { DatePipe, NgStyle } from '@angular/common';
import { Component, inject } from '@angular/core';
import { EEntityType, ERelationType, IJourneyLeg } from '@web/dtos';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { WebTextStore } from '../../../../services/api/text/web-text-store.service';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import { OnDemandJourneyViewModel } from '../on-demand-journey-view-model';
import { OnDemandSelectionStateService } from '../../../../services/on-demand/on-demand-selection-state.service';
import { formatSimpleTime } from '@web/shared-functions/date';
import {
  getTransportName,
  getTransferLabel,
  isTransferLeg,
} from '@web/shared-functions/journey';

@Component({
  selector: 'aw-on-demand-journey-timeline',
  templateUrl: './on-demand-journey-timeline.component.html',
  imports: [NgStyle, DatePipe, FilterTextsPipe, LanguagePipe],
})
export class OnDemandJourneyTimelineComponent {
  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly formatSimpleTime = formatSimpleTime;
  protected readonly getTransportName: typeof getTransportName =
    getTransportName;
  protected readonly getTransferLabel: typeof getTransferLabel =
    getTransferLabel;
  protected readonly isTransferLeg: typeof isTransferLeg = isTransferLeg;

  protected readonly corporateDesign: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly journey: OnDemandJourneyViewModel = inject(
    OnDemandJourneyViewModel
  );
  protected readonly selectionState: OnDemandSelectionStateService = inject(
    OnDemandSelectionStateService
  );
  protected readonly textStore: WebTextStore = inject(WebTextStore);

  protected getTransferDepartureTime(nextLeg?: IJourneyLeg): string | null {
    if (nextLeg && this.journey.isOnDemandLeg(nextLeg.operator.id)) {
      return this.selectionState.confirmedDeparture();
    }

    return null;
  }

  protected getTransferArrivalTime(previousLeg?: IJourneyLeg): string | null {
    if (previousLeg && this.journey.isOnDemandLeg(previousLeg.operator.id)) {
      return this.selectionState.confirmedArrival();
    }

    return null;
  }

  protected getDisplayDeparture(
    leg: IJourneyLeg,
    previousLeg?: IJourneyLeg
  ): string {
    if (
      this.isTransferLeg(leg) &&
      previousLeg &&
      this.journey.isOnDemandLeg(previousLeg.operator.id)
    ) {
      return this.selectionState.confirmedArrival();
    }

    return formatSimpleTime(leg.origin.time);
  }
}
